import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import Form from './form';
import MultiStepWrapper from '../../helpers/multi-step';
import { jsx as _jsx } from "theme-ui/jsx-runtime";

var MultiStepForm = function MultiStepForm(props) {
  var _props$schema, _props$schema$steps;

  return _jsx(MultiStepWrapper, _objectSpread(_objectSpread({
    totalSteps: props === null || props === void 0 ? void 0 : (_props$schema = props.schema) === null || _props$schema === void 0 ? void 0 : (_props$schema$steps = _props$schema.steps) === null || _props$schema$steps === void 0 ? void 0 : _props$schema$steps.length
  }, props), {}, {
    children: _jsx(Form, {})
  }));
};

export default MultiStepForm;
//# sourceMappingURL=index.js.map